<template>
  <div class="personal">
    <div
      v-show="!S_GlobalSearch && slideState && dataMsg == 'personal'"
      class="personal_tab"
      :style="{
        position: 'fixed',
        left: '82px',
        top: windowMove.top + 25 + 'px',
      }"
    >
      <div
        :class="{ active: personalTab == 'personalCategory' }"
        @click="personalTabFS('personalCategory')"
      >
        上传资源
      </div>
      <div
        :class="{ active: personalTab == 'collectionCategory' }"
        @click="personalTabFS('collectionCategory')"
      >
        收藏资源
      </div>
    </div>

    <!-- <div
      v-if="messageBarData.judge"
      class="messageBar"
      :style="{
        'position' : 'fixed',
        'left': judgeFixed?  windowMove.left + 'px' : (windowMove.left + 280 + 'px'),
        'top':  windowMove.top + 'px',
      }"
    >
      <span
        class="el-icon-close"
        @click="messageBarData.judge = false"
        style="
          position: absolute;
          top: 5px;
          right: 5px;
          font-weight: bold;
          color: #fff;
      "></span>
      <a
        v-if="messageBarData.judge"
        href="https://wiki.laihua.com/basic/appupload/appupload.html"
        target="_blank"
      >
        <span
          style="
            position: absolute;
            top: 0px;
            left: -5px;
            font-size: 12px;
            color: #fff;
            display: inline-block;
            transform: scale(0.9, 0.9);
            -ms-transform: scale(0.9, 0.9);
            -moz-transform: scale(0.9, 0.9);
            -webkit-transform: scale(0.9, 0.9);
            -o-transform: scale(0.9, 0.9);
          ">
          从“来画动画”APP上传的资源都会同步到这里
        </span>
      </a>
    </div>-->

    <div v-show="!S_GlobalSearch" style="padding-bottom: 50px">
      <audio
        v-if="soundData.testSound"
        ref="personalTestSound"
        :src="$handleAssetsUrl(soundData.testSound.url)"
        style="display: none"
      ></audio>

      <div
        class="data-body"
        v-for="(item, index) in category"
        :key="item.id"
        :class="[{ operation: dataArray[item.id].judge }, item.id + '-wrapper']"
        :style="{ height: dataArray[item.id].judge ? 'auto' : '140px' }"
        :data-cate-name="item.id"
        v-show="isShowFolder(personalTab, item.id)"
      >
        <section
          class="my-bg"
          :class="{ 'fix-section-top': fixTopId.id === item.id }"
          :style="{
            left: judgeFixed
              ? windowMove.left + 'px'
              : windowMove.left + 280 + 'px',
            top: windowMove.top + 'px',
          }"
          @click.stop="
            getUserCategories({ type: item.id, own: 1 }, $event);
            scrollTop(index);
            personalGetData(item);
            switchDataBoxAction(item.id);
            manageMaterialStepFS(2);
          "
        >
          <el-tooltip
            effect="dark"
            content="点击可展开/收起"
            placement="left"
            :open-delay="1000"
          >
            <img :src="item.iconUrl" width="auto" height="100%" />
          </el-tooltip>

          <span v-if="item.id == 'video'">
            {{ item.name }}(60s以内)
            <el-tooltip effect="dark" placement="top" :offset="-10">
              <span slot="content"
                >为保证导出效果,仅支持添加时长小于<br />60s的视频,其余视频将不在此处展示。</span
              >
              <span class="info-trigger">i</span>
            </el-tooltip>
          </span>
          <span v-else>{{ item.name }}</span>
        </section>

        <div
          class="switchData"
          v-if="
            false &&
            personalTab == 'personalCategory' &&
            !personalCategory[item.id].switchJudge.judge
          "
          :class="{
            'fix-section-top': fixTopId.id === item.id,
            'fix-switchData': fixTopId.id != item.id,
          }"
          :style="{
            left: judgeFixed
              ? windowMove.left + 'px'
              : windowMove.left + 280 + 'px',
            top: windowMove.top + 'px',
          }"
        >
          {{ personalCategory[item.id].switchJudge.msg }}
        </div>

        <div
          class="body-list"
          :style="{
            height: dataArray[item.id].data.length ? 'auto' : '80px',
            // --每个slide文件都会有注释这个css属性，禁止分组图固定在素材栏上方--
            // 'margin-top': fixTopId.id === (item.id) ? '120px' : '0px',
            // ----
            'margin-top': dataArray[item.id].judge ? '10px' : '25px',
            'padding-top': '12px',
            'align-content': 'flex-start',
          }"
        >
          <!--批量管理按钮-->
          <div
            v-if="
              (dataArray[item.id].data.length ||
                (cateOptions && cateOptions.length)) &&
              personalTab == 'personalCategory'
            "
            class="manageMaterial"
            style="paddingtop: 0; max-height: 30px"
          >
            <!-- <el-button
              v-if="manageMaterial.step == 2"
              type="info"
              plain
              size="small"
              @click="manageMaterialStepFS(2)"
            >&nbsp;&nbsp;取消&nbsp;&nbsp;</el-button>-->

            <!-- <el-button
              v-if="manageMaterial.step == 2 && manageMaterial.dataID"
              type="primary"
              size="small"
              @click="manageMaterialStepFS(3, item.id, $event)"
            >&nbsp;&nbsp;删除&nbsp;&nbsp;</el-button>-->

            <!-- <el-button
              v-if="manageMaterial.step == 2 && !manageMaterial.dataID"
              type="info"
              size="small"
              class="closeDel"
            >&nbsp;&nbsp;删除&nbsp;&nbsp;</el-button>-->

            <div
              v-if="manageMaterial.step == 2"
              class="checkboxBtn"
              :class="{
                checkboxBtnActive: manageMaterial.allIn,
              }"
              @click="manageMaterialStepFS('allIn', item.id)"
            >
              <!-- <span
                :class="{
                  'el-icon-arrow-down' : manageMaterial.allIn
                }"
              ></span>全选-->
              <el-checkbox
                :indeterminate="
                  manageMaterial.dataID.length > 0 && !manageMaterial.allIn
                "
                @change="onAllSelectedChange"
                >全选</el-checkbox
              >
            </div>

            <template v-if="manageMaterial.step == 2">
              <div
                class="manage-btn move"
                :class="{ disabled: !manageMaterial.dataID }"
                @click="manageMaterial.dataID && moveToCategory()"
              >
                <i></i>
                <span>移动</span>
              </div>
              <div
                class="manage-btn remove"
                :class="{ disabled: !manageMaterial.dataID }"
                @click="
                  manageMaterial.dataID &&
                    manageMaterialStepFS(3, item.id, $event)
                "
              >
                <i></i>
                <span>删除</span>
              </div>
              <div class="manage-btn cancel" @click="manageMaterialStepFS(2)">
                <i></i>
                <span>取消</span>
              </div>
            </template>

            <!-- <el-button
              v-if="manageMaterial.step == 1"
              class="personalSetting"
              type="primary"
              size="small"
              @click="
                manageMaterialStepFS(1);
                materialPushAnalysis({type: 'personalSetting'});
              "
            >&nbsp;&nbsp;&nbsp;管理&nbsp;</el-button>-->

            <div
              v-if="manageMaterial.step == 1"
              class="manage-btn manage"
              @click="
                manageMaterialStepFS(1);
                materialPushAnalysis({ type: 'personalSetting' });
              "
            >
              <i></i>
              <span>管理</span>
            </div>

            <!-- <el-button
              v-if="manageMaterial.step == 1"
              class="personalSetting"
              type="primary"
              size="small"
              @click="
                setUserCategories()
              "
            >&nbsp;&nbsp;&nbsp;分类配置&nbsp;</el-button>-->
            <div
              v-if="manageMaterial.step == 1"
              class="manage-btn cate"
              @click="setUserCategories()"
            >
              <i></i>
              <span>分类配置</span>
            </div>
          </div>
          <!-- 管理按钮 end -->

          <!-- 分类菜单 -->
          <DropDownMenu
            v-if="
              personalTab == 'personalCategory' &&
              cateOptions &&
              cateOptions.length
            "
            :options="cateOptions"
            :selectedIndex="selectedCateIndex"
            all="默认文件夹"
            :myStyle="{
              height: '38px',
              zIndex: 300,
              marginBottom: '10px',
            }"
            :disabled="manageMaterial.step == 2"
            @clickItem="getDataByUserCate"
          ></DropDownMenu>

          <!--pic / 包含收藏背景-->
          <div
            v-if="
              item.id === 'pic' &&
              !dataArray[item.id].data.length &&
              personalTab == 'personalCategory'
            "
            class="add-bg"
            style="margin-bottom: 5px"
          >
            <label for="imagePic">
              <div>
                <span style="position: relative; top: -1px; left: -10px"
                  >+</span
                >
                <span>上传素材</span>
              </div>
            </label>
            <el-tooltip
              effect="dark"
              content="请上传PNG/JPG/JPEG格式的图片，大小不超过10M"
              placement="top"
              :open-delay="1000"
            >
              <span
                class="el-icon-question"
                style="
                  position: absolute;
                  top: 27px;
                  left: 135px;
                  font-size: 20px;
                  color: #a3a6cd;
                "
              ></span>
            </el-tooltip>
          </div>
          <div
            v-if="item.id === 'pic' || item.id === 'bg'"
            class="item itemImg"
            :class="{
              manageMaterialItemAction: manageMaterial.dataArray[itemL.id],
              persona_flex_margin_right: personalTab == 'personalCategory',
              collection_flex_margin_right: personalTab == 'collectionCategory',
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            @mouseover="getCharacters($event, itemL)"
            @mouseout="closeCharacters()"
            @click="
              BgOperation === 'swap' && getItemCategoryLabe(itemL.url) === 'GIF'
                ? () => {}
                : picItemClickFS(itemL)
            "
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              @error="imgErroeFs($event, itemL)"
              width="auto"
              height="100%"
            />
            <div
              class="maskItem"
              :class="{
                disabled:
                  BgOperation === 'swap' &&
                  getItemCategoryLabe(itemL.url) === 'GIF',
              }"
            ></div>

            <div
              v-if="
                manageMaterial.step == 2 && personalTab == 'personalCategory'
              "
              class="manageMaterialMask"
              :class="{
                manageMaterialMaskAction: manageMaterial.dataArray[itemL.id],
              }"
              @click="
                stopDocument($event);
                manageMaterialStepFS(4, itemL, $event);
              "
              @mouseover="stopDocument($event)"
            >
              <span class="manageMaterialMaskIcon el-icon-check"></span>
            </div>

            <div class="itemCategoryLabe">
              <span>{{ getItemCategoryLabe(itemL.url) }}</span>
            </div>
            <el-tooltip
              v-if="
                switchDataType == 0 &&
                manageMaterial.step == 1 &&
                personalTab == 'personalCategory'
              "
              effect="dark"
              content="设置为背景"
              placement="bottom"
              :open-delay="1000"
            >
              <span
                v-if="!isGifOrLottie(itemL.url)"
                @mouseover="stopDocument($event)"
                @click.stop="
                  settingScenesBg(itemL);
                  materialPushAnalysis({ type: 'imgSettingBg' });
                "
                class="modify modifyBg"
                style="
                  width: 30px;
                  height: 30px;
                  line-height: 20px;
                  left: 0px;
                  bottom: 0px;
                  border-radius: 0;
                "
              ></span>
            </el-tooltip>

            <vipLabel
              v-if="personalTab == 'collectionCategory'"
              :payType="itemL.payType"
              :itemData="itemL"
              :boxName="item.id"
            />

            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!--video-->
          <div
            v-if="item.id === 'video' && !dataArray[item.id].data.length"
            class="add-bg"
            style="margin-bottom: 5px"
          >
            <label for="videoMe">
              <div>
                <span style="position: relative; top: -1px; left: -10px"
                  >+</span
                >
                <span>上传视频</span>
              </div>
            </label>
          </div>
          <div
            class="item itemImg"
            :class="{
              manageMaterialItemAction: manageMaterial.dataArray[itemL.id],
              persona_flex_margin_right: personalTab == 'personalCategory',
              collection_flex_margin_right: personalTab == 'collectionCategory',
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-if="item.id === 'video'"
            v-for="(itemL, indexL) in (dataArray[item.id].data || []).filter(
              (v) => (v.duration || v.times) < 60
            )"
            @mouseover="getCharacters($event, itemL)"
            @mouseout="closeCharacters()"
            @click="picItemClickFS(itemL, 'video')"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <span
              @mouseover="stopDocument($event)"
              class="label labelVideo el-icon-caret-right"
              style="
                right: 0;
                left: 5px;
                width: 18px;
                border-radius: 100%;
                background: #595574;
                z-index: 5;
              "
            ></span>
            <div class="maskItem"></div>

            <div
              class="manageMaterialMask"
              :class="{
                manageMaterialMaskAction: manageMaterial.dataArray[itemL.id],
              }"
              v-if="manageMaterial.step == 2"
              @click="
                stopDocument($event);
                manageMaterialStepFS(4, itemL, $event);
              "
              @mouseover="stopDocument($event)"
            >
              <span class="manageMaterialMaskIcon el-icon-check"></span>
            </div>

            <el-tooltip
              effect="dark"
              content="设置为背景"
              placement="bottom"
              :open-delay="1000"
              v-if="switchDataType == 0 && manageMaterial.step == 1"
            >
              <span
                @mouseover="stopDocument($event)"
                @click.stop="
                  addVideoSprite(itemL, 'bg');
                  materialPushAnalysis({ type: 'imgSettingBg' });
                  $analysis(
                    'my_resource,click_video_setbg,我的资源_视频_点击视频为背景'
                  );
                "
                class="modify modifyBg"
                style="
                  width: 30px;
                  height: 30px;
                  line-height: 20px;
                  left: 0px;
                  bottom: 0px;
                  border-radius: 0;
                "
              ></span>
            </el-tooltip>
          </div>

          <!--gif-->

          <!-- <div
            v-if="item.id === 'gif' && !dataArray[item.id].data.length && personalTab == 'collectionCategory'"
            class="add-bg"
            style="margin-bottom: 5px;"
          >
            <label for="gif">
              <div>
                <span style="position: relative; top: -1px; left: -10px;">+</span>
                <span>上传GIF图</span>
              </div>
            </label>
            <el-tooltip
              effect="dark"
              content="请上传GIF格式的图片，大小不超过10M"
              placement="top"
              :open-delay="1000"
            >
              <span
                class="el-icon-question"
                style="position: absolute; top: 27px; left: 135px; font-size: 20px; color: #a3a6cd;"
              ></span>
            </el-tooltip>
          </div>-->
          <div
            v-if="item.id === 'gif'"
            class="item itemImg"
            :class="{
              manageMaterialItemAction: manageMaterial.dataArray[itemL.id],
              persona_flex_margin_right: personalTab == 'personalCategory',
              collection_flex_margin_right: personalTab == 'collectionCategory',
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            @mouseover="getCharacters($event, itemL)"
            @mouseout="closeCharacters()"
            @click="slidAddSprites(itemL)"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              @error="imgErroeFs($event, itemL)"
              width="auto"
              height="100%"
            />
            <div class="maskItem"></div>

            <div
              v-if="
                manageMaterial.step == 2 && personalTab == 'personalCategory'
              "
              class="manageMaterialMask"
              :class="{
                manageMaterialMaskAction: manageMaterial.dataArray[itemL.id],
              }"
              @click="
                stopDocument($event);
                manageMaterialStepFS(4, itemL, $event);
              "
              @mouseover="stopDocument($event)"
            >
              <span class="manageMaterialMaskIcon el-icon-check"></span>
            </div>

            <vipLabel
              v-if="personalTab == 'collectionCategory'"
              :payType="itemL.payType"
              :itemData="itemL"
              :boxName="item.id"
            />

            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!--scene / 包含收藏场景-->
          <div
            v-if="
              item.id === 'scene' &&
              !dataArray[item.id].data.length &&
              personalTab == 'personalCategory'
            "
            class="add-bg"
            style="margin-bottom: 5px"
          >
            <div @click="collectScenes()" style="text-indent: 12px">
              <span style="position: relative; top: -1px; left: -2px">+</span>
              <span>收藏当前场景</span>
            </div>
          </div>
          <div
            class="item itemScene"
            :class="{
              manageMaterialItemAction: manageMaterial.dataArray[itemL.id],
              persona_flex_margin_right: personalTab == 'personalCategory',
              collection_flex_margin_right: personalTab == 'collectionCategory',
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-if="item.id === 'scene' || item.id === 'scenes'"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            @click="upodatasecens(itemL.id, 0, itemL)"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              @error="sceneErroeFs($event)"
              width="auto"
              height="100%"
            />
            <div class="maskItem"></div>

            <div
              v-if="
                manageMaterial.step == 2 && personalTab == 'personalCategory'
              "
              class="manageMaterialMask"
              :class="{
                manageMaterialMaskAction: manageMaterial.dataArray[itemL.id],
              }"
              @click="
                stopDocument($event);
                manageMaterialStepFS(4, itemL, $event);
              "
              @mouseover="stopDocument($event)"
            >
              <span class="manageMaterialMaskIcon el-icon-check"></span>
            </div>

            <el-tooltip
              v-if="
                manageMaterial.step == 1 && personalTab == 'personalCategory'
              "
              effect="dark"
              content="取消收藏"
              placement="bottom"
              :open-delay="1000"
            >
              <span
                @mouseover="stopDocument($event)"
                @click="
                  stopDocument($event);
                  modifyPopups(itemL, item.id, $event);
                "
                class="modify modifyScene"
                style="
                  width: 30px;
                  height: 30px;
                  line-height: 20px;
                  left: 92px;
                  bottom: 5px;
                "
              >
                <span class></span>
              </span>
            </el-tooltip>

            <vipLabel
              v-if="personalTab == 'collectionCategory'"
              :payType="itemL.payType"
              :itemData="itemL"
              :boxName="item.id"
            />

            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon collection_sprite_icon_active"
                :class="['vipResource_' + itemL.id]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!-- sound -->
          <div v-if="item.id === 'music' || item.id === 'sound'">
            <NewSoundFeature></NewSoundFeature>
          </div>
          <!--audio tool / 包含收藏背景音乐-->
          <div
            v-if="item.id === 'music' && personalTab == 'personalCategory'"
            class="add-bg"
            style="margin-bottom: 5px"
          >
            <label for="music" v-if="!dataArray[item.id].data.length">
              <div style="text-indent: 12px">
                <span style="position: relative; top: -1px; left: -2px">+</span>
                <span>上传音频</span>
              </div>
            </label>
          </div>
          <div
            v-if="item.id === 'music' || item.id === 'sound'"
            class="itemAudio"
            :class="{
              manageMaterialItemAction: manageMaterial.dataArray[itemL.id],
              collection_itemAudio: personalTab == 'collectionCategory',
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            :key="itemL.id"
            :style="{
              backgroundColor:
                soundData.toolSound.resourceId === itemL.id ? '#e7e7fb' : '',
            }"
          >
            <!-- 播放 -->
            <div class="playGrid">
              <el-tooltip
                effect="dark"
                content="试听"
                placement="bottom"
                :open-delay="1000"
              >
                <span
                  @click="testListenSound(itemL)"
                  :class="{
                    stop:
                      soundData.playType && soundData.testSound.id === itemL.id,
                    play:
                      !soundData.playType || soundData.testSound.id != itemL.id,
                  }"
                  style="margin: 0"
                ></span>
              </el-tooltip>
            </div>
            <div class="detailGrid">
              <el-tooltip
                effect="dark"
                :content="itemL.title"
                placement="left"
                :open-delay="1000"
              >
                <p class="name">{{ itemL.title }}</p>
              </el-tooltip>
              <p class="duration">{{ resultFormat(itemL.duration) }}</p>
            </div>
            <div class="infoGrid">
              <div class="staticGrid">
                <div class="logoGrid">
                  <company :itemData="itemL" :boxName="boxName" />
                </div>
              </div>

              <div class="selectedGrid">
                <el-tooltip
                  v-if="personalTab == 'personalCategory'"
                  effect="dark"
                  content="删除"
                  placement="bottom"
                  :open-delay="1000"
                >
                  <span
                    class="delAudio"
                    @click="modifyPopups(itemL, item.id, $event)"
                  >
                    <span></span>
                  </span>
                </el-tooltip>
                <el-tooltip
                  effect="dark"
                  content="使用"
                  placement="bottom"
                  :open-delay="1000"
                  v-if="manageMaterial.step == 1"
                >
                  <el-popover
                    placement="right"
                    width="90"
                    trigger="hover"
                    close-delay="0"
                  >
                    <div class="set-sound-content">
                      <div @click="setMusic(itemL)">设置为背景音乐</div>
                      <div @click="setDub(itemL)">设置为全局旁白</div>
                      <div @click="setDubInScene(itemL)">设置为单页旁白</div>
                    </div>
                    <span
                      slot="reference"
                      :class="
                        soundData.toolSound.resourceId === itemL.id
                          ? 'select-active'
                          : 'select'
                      "
                    ></span>
                  </el-popover>
                </el-tooltip>
              </div>
            </div>
            <span
              v-if="
                manageMaterial.step == 2 && personalTab == 'personalCategory'
              "
              class="manageMaterialMaskAudio"
              :class="{
                'manageMaterialMaskAction el-icon-check':
                  manageMaterial.dataArray[itemL.id],
              }"
              :style="{
                'border-color': manageMaterial.dataArray[itemL.id]
                  ? '#5175ff'
                  : '#d8ddea',
              }"
              @click="manageMaterialStepFS(4, itemL, $event, item.id)"
            ></span>
          </div>

          <!--audio scenes-->
          <div
            v-if="item.id === 'musicType'"
            class="add-bg"
            style="margin-bottom: 5px"
          >
            <div
              v-if="!dataArray[item.id].data.length"
              style="text-indent: 33px"
              @click="uploadFs('audio', $event)"
            >
              <span style="position: relative; top: -1px; left: -10px">+</span>
              <span>上传录音</span>
            </div>
            <div
              v-if="false && soundData.sceneSoundData && UserMsg.levelType <= 1"
              class="audioScenesMsg"
            >
              <el-tooltip effect="dark" placement="left" :open-delay="1000">
                <div slot="content">
                  购买标准会员后，我们会根据您购
                  <br />
                  <br />买的时长赠送免费使用录音的次数。
                  <br />
                  <br />若在项目中添加了录音并导出视频
                  <br />
                  <br />后，则算消耗了一次使用次数。
                  <br />
                  <br />
                </div>
                <span
                  class="el-icon-question"
                  style="position: relative; top: 0px; left: 5px"
                ></span>
              </el-tooltip>
              <span
                class="el-icon-close"
                @click="soundData.sceneSoundData = false"
                style="
                  position: absolute;
                  top: 10px;
                  right: 15px;
                  font-weight: bold;
                  color: #fff;
                "
              ></span>
              <span style="margin-left: 5px"
                >您剩余{{
                  UserMsg.uploadRecordingRemain > 0
                    ? UserMsg.uploadRecordingRemain
                    : 0
                }}次免费使用录音次数</span
              >
            </div>
          </div>
          <div
            class="itemAudio"
            v-if="item.id === 'musicType'"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            :class="{
              loadingOut:
                indexL < 3 ? !recordUploadData['RU_' + indexL] : false,
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            :key="itemL.id"
            :style="{
              backgroundColor: soundData.sceneSound
                ? soundData.sceneSound.resourceId === itemL.id
                  ? '#e7e7fb'
                  : ''
                : '',
            }"
          >
            <div class="detail" style="justify-content: space-between">
              <p class="name">{{ itemL.title }}</p>
              <p class="duration">
                {{ resultFormat(itemL.duration) }}
                <span
                  class="loadingOutMsg"
                  v-if="indexL < 3 ? !recordUploadData['RU_' + indexL] : false"
                  >(正在转码中...)</span
                >
              </p>
            </div>
            <div
              v-if="manageMaterial.step == 1"
              class="detail"
              style="justify-content: end; align-items: center"
            >
              <el-tooltip
                effect="dark"
                content="试听"
                placement="bottom"
                :open-delay="1000"
              >
                <span
                  @click="
                    testListenSound(
                      itemL,
                      indexL < 3 ? !recordUploadData['RU_' + indexL] : false
                    )
                  "
                  :class="{
                    stop:
                      soundData.playType && soundData.testSound.id === itemL.id,
                    play:
                      !soundData.playType || soundData.testSound.id != itemL.id,
                    'odd-index': indexL % 2 === 1,
                    'even-index': indexL % 2 === 0,
                  }"
                ></span>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                content="使用"
                placement="bottom"
                :open-delay="1000"
                v-if="
                  manageMaterial.step == 1 &&
                  (indexL < 3 ? recordUploadData['RU_' + indexL] : true)
                "
              >
                <span
                  :class="
                    soundData.sceneSound.resourceId === itemL.id
                      ? 'select-active'
                      : 'select'
                  "
                  @click="setSceneSound(itemL)"
                ></span>
              </el-tooltip>

              <el-tooltip
                effect="dark"
                content="删除"
                placement="bottom"
                :open-delay="1000"
                v-if="
                  manageMaterial.step == 1 &&
                  (indexL < 3 ? recordUploadData['RU_' + indexL] : true)
                "
              >
                <span
                  class="delAudio"
                  @click="modifyPopups(itemL, item.id, $event)"
                >
                  <span class></span>
                </span>
              </el-tooltip>
            </div>

            <span
              class="manageMaterialMaskAudio"
              :class="{
                'manageMaterialMaskAction el-icon-check':
                  manageMaterial.dataArray[itemL.id],
              }"
              :style="{
                'border-color': manageMaterial.dataArray[itemL.id]
                  ? '#5175ff'
                  : '#d8ddea',
              }"
              v-if="
                manageMaterial.step == 2 &&
                (indexL < 3 ? recordUploadData['RU_' + indexL] : true)
              "
              @click="manageMaterialStepFS(4, itemL, $event, item.id)"
            ></span>
          </div>

          <!-- 文字 -->
          <div
            v-if="item.id === 'text'"
            class="item itemText"
            :class="{
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
              @click="
                materialPushAnalysis({
                  type: 'text',
                  id: item.id,
                  name: item.name,
                });
                slidAddSprites(itemL);
              "
            />

            <vipLabel
              v-if="personalTab == 'collectionCategory'"
              :payType="itemL.payType"
              :itemData="itemL"
              :boxName="item.id"
            />

            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!-- 形状 -->
          <div
            v-if="item.id === 'shapes'"
            class="item itemScene itemShapes"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            @mouseenter="
              loadLottieShapes(
                itemL,
                { index: indexL, id: 'shapes_' + item.id },
                true
              )
            "
            @mouseleave="
              loadLottieShapes(
                itemL,
                { index: indexL, id: 'shapes_' + item.id },
                false
              )
            "
            @click="
              slidAddSprites(itemL);
              materialPushAnalysis({
                type: 'shape',
                id: item.id,
                name: item.name,
              });
            "
            :key="itemL.id"
            :class="{
              persona_flex_margin_right: personalTab == 'personalCategory',
              collection_flex_margin_right: personalTab == 'collectionCategory',
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
          >
            <img
              :class="{ Imglottie: itemL.fileType === 8 }"
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <div
              class="mask"
              :class="{ Clottie: itemL.fileType === 8 }"
              :ref="'shapes_' + item.id"
            ></div>

            <vipLabel
              v-if="personalTab == 'collectionCategory'"
              :payType="itemL.payType"
              :itemData="itemL"
              :boxName="item.id"
            />

            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!-- 道具 -->
          <div
            v-if="item.id === 'props'"
            class="item itemProps"
            :class="{
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            @mouseenter="
              loadLottie(itemL, { index: indexL, id: 'props_' + item.id }, true)
            "
            @mouseleave="
              loadLottie(
                itemL,
                { index: indexL, id: 'props_' + item.id },
                false
              )
            "
            :key="itemL.id"
            @click="
              slidAddSprites(itemL);
              materialPushAnalysis({
                type: 'props',
                id: item.id,
                name: item.name,
                itemType: itemL.fileType,
              });
            "
          >
            <img
              v-if="itemL.fileType !== 42"
              :class="{ Imglottie: itemL.fileType === 5 }"
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
            />

            <video
              v-if="itemL.fileType == 42"
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              width="auto"
              height="100%"
              loop="loop"
            ></video>
            <div
              class="mask"
              :class="{ Clottie: itemL.fileType === 5 }"
              :ref="'props_' + item.id"
            ></div>

            <vipLabel
              v-if="personalTab == 'collectionCategory'"
              :payType="itemL.payType"
              :itemData="itemL"
              :boxName="item.id"
            />

            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!-- 角色 -->
          <div
            class="item itemProps"
            :class="{
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            v-if="itemL.action && itemL.action[0] && item.id === 'characters'"
            @mouseover="
              getCharacters($event, itemL, true, item.id);
              loadLottieCharacters(
                itemL.action[0],
                { index: indexL, id: 'characters_' + item.id },
                true
              );
            "
            @mouseout="
              closeCharacters();
              loadLottieCharacters(
                itemL.action[0],
                { index: indexL, id: 'characters_' + item.id },
                false
              );
            "
            :key="itemL.id"
            @click="
              slidAddSprites(itemL.action[0]);
              materialPushAnalysis({
                type: 'character',
                id: item.id,
                name: item.name,
              });
            "
            :style="{
              top: itemL.topWFC + 'px',
              left: itemL.leftWFC + 'px',
            }"
          >
            <img
              class="Imglottie"
              :src="$handleAssetsUrl(itemL.action[0].thumbnailUrl)"
              width="auto"
              height="100%"
            />
            <div class="Clottie" :ref="'characters_' + item.id"></div>
            <span class="mask" style="z-index: 8"></span>

            <vipLabel
              v-if="personalTab == 'collectionCategory'"
              :payType="itemL.payType"
              :itemData="itemL"
              :boxName="item.id"
            />

            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon"
                :class="[
                  { collection_sprite_icon_active: itemL.favorites },
                  'vipResource_' + itemL.id,
                ]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!-- 模版 -->
          <div
            class="item itemScene"
            :class="{
              manageMaterialItemAction: manageMaterial.dataArray[itemL.id],
              persona_flex_margin_right: personalTab == 'personalCategory',
              collection_flex_margin_right: personalTab == 'collectionCategory',
              'odd-index': indexL % 2 === 1,
              'even-index': indexL % 2 === 0,
            }"
            v-if="item.id === 'template'"
            v-for="(itemL, indexL) in dataArray[item.id].data"
            @click="addTemplate(itemL)"
            @mouseover="
              getCharacters(
                $event,
                Object.assign(
                  {
                    fileType: 'template',
                    url: itemL.videoUrl,
                  },
                  itemL
                )
              )
            "
            @mouseout="closeCharacters()"
            :key="itemL.id"
          >
            <img
              :src="$handleAssetsUrl(itemL.thumbnailUrl)"
              @error="sceneErroeFs($event)"
              width="auto"
              height="100%"
            />
            <div class="maskItem"></div>

            <div
              v-if="
                manageMaterial.step == 2 && personalTab == 'personalCategory'
              "
              class="manageMaterialMask"
              :class="{
                manageMaterialMaskAction: manageMaterial.dataArray[itemL.id],
              }"
              @click="
                stopDocument($event);
                manageMaterialStepFS(4, itemL, $event);
              "
              @mouseover="stopDocument($event)"
            >
              <span class="manageMaterialMaskIcon el-icon-check"></span>
            </div>

            <el-tooltip
              v-if="
                manageMaterial.step == 1 && personalTab == 'personalCategory'
              "
              effect="dark"
              content="取消收藏"
              placement="bottom"
              :open-delay="1000"
            >
              <span
                @mouseover="stopDocument($event)"
                @click="
                  stopDocument($event);
                  modifyPopups(itemL, item.id, $event);
                "
                class="modify modifyScene"
                style="
                  width: 30px;
                  height: 30px;
                  line-height: 20px;
                  left: 92px;
                  bottom: 5px;
                "
              >
                <span class></span>
              </span>
            </el-tooltip>

            <span
              class="label"
              :class="['price-tag_' + itemL.id]"
              v-if="itemL.tt"
              style="
                bottom: 5px;
                right: 5px;
                left: auto;
                width: auto;
                padding: 0 3px;
              "
              >已购买</span
            >

            <span
              v-if="
                itemL.payType &&
                (!UserEquity.exclusive || isPersonVip) &&
                !itemL.tt &&
                personalTab == 'collectionCategory'
              "
              class="label"
              style="
                bottom: 5px;
                right: 5px;
                left: auto;
                width: auto;
                padding: 0 3px;
              "
              >¥ {{ itemL.price }}</span
            >
            <el-tooltip
              v-if="personalTab == 'collectionCategory'"
              effect="dark"
              content="收藏"
              placement="top"
              :open-delay="1000"
            >
              <i
                class="collection_sprite_icon collection_sprite_icon_active"
                :class="['vipResource_' + itemL.id]"
                @mouseover="
                  collectionSpriteIconTit($event);
                  stopDocument($event);
                "
                @click="
                  stopDocument($event);
                  collectionSpriteIconFS(
                    itemL,
                    $event,
                    collectionCategory[item.id].type
                  );
                "
              ></i>
            </el-tooltip>
          </div>

          <!--loading-->
          <div
            v-loading="loading"
            v-if="loading"
            element-loading-background="rgba(0, 0, 0, 0)"
            element-loading-text="加载中..."
            element-loading-spinner="el-laihua-loading"
            style="width: 100%; height: 20px; margin-top: 35px"
          ></div>
        </div>
      </div>

      <SwitchStyle />
      <CategoryPrompt
        v-show="slideState && dataMsg == 'personal'"
        v-model="fixTopId"
        :windowMove="windowMove"
        :judgeFixed="judgeFixed"
        :boxName="boxName"
        :dataArray="dataArray"
        :addHeight="7"
        :myStyle="{
          zIndex: 350,
        }"
      />
    </div>

    <div v-show="S_GlobalSearch">
      <Search
        :boxName="boxName"
        :dataMsg="dataMsg"
        v-on:addsprite="settingScenesBg"
        :searchDataArray="dataArray"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import rightnavSlide from "../../mixins/rightnavSlide";
import Search from "./search/search";
import domtoimage from "dom-to-image";
import Analysis from "../../mixins/analysis/materialBu";
import DropDownMenu from "../controls/menu";
import userCategoriesMixin from "./userCategoriesMixin";
import NewSoundFeature from '../newSoundFeature.vue';
import addSound from './addSound.js';

export default {
  name: 'personalMaterial',
  mixins: [rightnavSlide, Analysis, userCategoriesMixin, addSound],
  data () {
    return {
      boxName: "personal", // 素材盒子的名字
      personalTab: "personalCategory",
      personalCategory: {
        // 个人素材列表
        // scene     : {  // 个人场景与素材场景合并
        //   id       : 'scene',
        //   name     : '场景页',
        //   iconUrl  : '/static/img/myscenes0.jpg',
        //   switchJudge : {
        //     judge : true,
        //     msg   : '',
        //   },
        // },
        pic: {
          id: "pic",
          name: "素材",
          iconUrl: "/static/img/mypic0.jpg",
          switchJudge: {
            judge: true,
            msg: ""
          }
        },
        music: {
          id: "music",
          name: "音频",
          iconUrl: "/static/img/mybgsound0.jpg",
          switchJudge: {
            judge: true,
            msg: ""
          }
        },
        // musicType: {
        //   id: "musicType",
        //   name: "录音",
        //   iconUrl: "/static/img/mysound0.jpg",
        //   switchJudge: {
        //     judge: true,
        //     msg: ""
        //   }
        // },
        // gif: {
        //   id: 'gif',
        //   name: 'GIF图',
        //   iconUrl: '/static/img/mygif0.jpg',
        //   switchJudge: {
        //     judge: true,
        //     msg: ''
        //   }
        // },
        video: {
          id: "video",
          name: "视频",
          iconUrl: "/static/img/myvideo0.jpg",
          switchJudge: {
            judge: true,
            msg: ""
          }
        }
      },
      collectionCategory: {
        template: {
          id: "template",
          name: "模板",
          iconUrl: "/static/img/my-template0.jpg",
          type: "template"
        },
        scenes: {
          id: "scenes",
          name: "场景页",
          iconUrl: "/static/img/myscenes0.jpg",
          type: 12
        },
        bg: {
          id: "bg",
          name: "背景",
          iconUrl: "/static/img/collection-bg.jpg",
          type: 3
        },
        text: {
          id: "text",
          name: "文字",
          iconUrl: "/static/img/collection-text.jpg",
          type: 16
        },
        characters: {
          id: "characters",
          name: "角色",
          iconUrl: "/static/img/collection-characters.jpg",
          type: 14
        },
        props: {
          id: "props",
          name: "道具",
          iconUrl: "/static/img/collection-props.jpg",
          type: 17
        },
        gif: {
          id: "gif",
          name: "GIF",
          iconUrl: "/static/img/collection-gif.jpg",
          type: 37
        },
        shapes: {
          id: "shapes",
          name: "形状",
          iconUrl: "/static/img/collection-shapes.jpg",
          type: 15
        },
        sound: {
          id: "sound",
          name: "音乐",
          iconUrl: "/static/img/collection-sound.jpg",
          type: 5
        }
      },
      dataArray: [], // 数据数组
      scollTop: {
        // 控制滚动条的数据
        default: -3, // 默认添加的高度
        Incremental: 140, // 单个分类的高度
        material: 75 // 单个元素的高度
      },
      dataSet: {
        // 请求数据对象
        pIndex: 0,
        type: 3,
        sOfPage: 24,
        fPage: 24,
        style: null
      },
      myScenesData: {}, // 保存场景的截图，判断当前场景的截图是否存在，不存在则替换
      soundData: {
        toolSound: "",
        sceneSound: "",
        testSound: "",
        playType: false,
        sceneSoundData: true
      },
      messageBarData: {
        judge: false,
        data: "",
        once: false
      },
      switchDataType: 0,
      manageMaterial: {
        // 批量管理数据存储
        dataArray: {}, // 被删除素材数组
        dataID: "", // 要删除的id
        step: 1, // 管理操作步骤，1--默认状态，2--执行添加素材进栈
        allIn: true
      },
      recordUploadData: {
        // 录音相关数据
        judge: true,
        RU_0: false,
        RU_1: false,
        RU_2: false
      },
      cateOptions: [],
      selectedCateIndex: -1
    };
  },
  watch: {
    dataMsg: function (val, oldval) {
      // 打开盒子操作
      if (this.dataMsg === this.boxName) {
        if (!this.messageBarData.once) {
          this.messageBarData.once = true;
          this.messageBarData.data = this.$util.localStorage.get(
            "MESSAGE-APP-data"
          );
          if (!this.messageBarData.data) {
            let messageTestData = { type: true };
            this.messageBarData.data = messageTestData;
            this.$util.localStorage.set("MESSAGE-APP-data", messageTestData);
            let timeoutid = setTimeout(() => {
              this.messageBarData.judge = true;
              clearTimeout(timeoutid);
            }, 300);
          }
        }
        if (this.personalTab == "collectionCategory") {
          // 收藏元素后关闭所有窗口
          for (let item in this.dataArray) {
            if (this.dataArray[item].judge) {
              this.dataArray[item].data = [];
              this.dataArray[item].pIndex = 1;
            }
          }

          this.dataBoxAction();
        }
      } else {
        this.testListenSound(false);
      }
    },
    BgOperation: {
      handler (val) {
        if (val == "add") {
          this.switchBgSpritesFS(0);
        } else {
          this.switchBgSpritesFS(2);
        }
      }
    },
    slideState: function (val, oldval) {
      // 打开盒子操作
      if (!this.slideState) {
        this.testListenSound(false);
      }
    },
    "TOOL.sound": function () {
      // 监控bgm改变
      if (this.TOOL.sound && this.TOOL.sound.url) {
        let TOOLData = this.TOOL.toJson();
        this.soundData.toolSound = TOOLData.sound[0];
      } else {
        this.soundData.toolSound = "";
      }
    },
    SelectScenes_Msg: function (val, oldval) {
      // 加载分组音乐
      if (this.SelectScenes_Msg.sound && this.SelectScenes_Msg.sound.url) {
        this.soundData.sceneSound = this.SelectScenes_Msg.toJson().sound[0];
      } else {
        this.soundData.sceneSound = "";
      }
    },
    SpriteOperation: {
      handler (val) {
        if (val == "add") {
          this.switchBgSpritesFS(0);
        } else {
          this.switchBgSpritesFS(1);
        }
      }
    },
    "manageMaterial.step": function (val, oldval) {
      switch (this.manageMaterial.step) {
        case 1:
          this.manageMaterial.dataArray = [];
          this.manageMaterial.dataArray.dataID = "";
          break;
        case 2:
          break;
      }
    },
    "SelectScenes_Msg.sound": function (val, oldval) {
      // 加载分组音乐
      if (this.SelectScenes_Msg.sound && this.SelectScenes_Msg.sound.url) {
        this.soundData.sceneSound = this.SelectScenes_Msg.toJson().sound[0];
      } else {
        this.soundData.sceneSound = "";
      }
    },
    "TOOL.soundRecord": function (val, oldval) {
      // 加载分组音乐
      if (val) {
        this.soundData.sceneSound = this.TOOL.getSoundRecord();
      } else {
        if (!this.SelectScenes_Msg.sound) {
          this.soundData.sceneSound = "";
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "TopNav_Size",
      "SetPanel_Size",
      "Window_Size",
      "SelectScenes_Msg",
      "MaterialPane_Size",
      "isPersonVip",
      "BgOperation"
    ]),
    ...mapGetters({
      receiveData: "addSoundtrack/getReceiveData",
      musicArr: 'addSoundtrack/getMusicArr',
      dubbingArr: 'addSoundtrack/getDubbingArr',
      soundHandle: "addSoundtrack/getPlayHandle"
    })
  },
  created () {
    this.$bus.on("setUserCategories.added", category => {
      let myCate = {
        id: category.id,
        name: category.name
      };
      this.cateOptions.push(myCate);
    });

    this.$bus.on("setUserCategories.updated", (category, i) => {
      this.cateOptions.some(v => {
        let isMatch = v.id === category.id;
        if (isMatch) {
          this.$set(v, "name", category.name);
        }

        return isMatch;
      });
    });

    this.$bus.on("setUserCategories.removed", (category, isClear, index) => {
      this.cateOptions.some((v, i) => {
        let isMatch = v.id === category.id;
        if (isMatch) {
          if (i === this.selectedCateIndex) {
            this.getDataByUserCate(-1);
          }
          this.cateOptions.splice(i, 1);
        }

        return isMatch;
      });
    });

    this.$bus.on("moveToCategory.done", index => {
      this.manageMaterialStepFS(2);
      this.getDataByUserCate(index);
      this.$modal.hide("moveToCategory");
    });

    this.$bus.on(
      "relateMaterialDone",
      ({ materials = [], materialTypeName } = {}) => {
        // const idsDict = {
        //   pic: 4,
        //   music: 5,
        //   musicType: 5,
        //   gif: 4,
        //   video: 1
        // };
        if (this.selectedCateIndex < 0) {
          return;
        }
        let uiType = this.getUIType();
        let tasks = materials.map((item) => {
          let id = '';
          if (typeof item === 'string') {
            id = item;
          } else if (item) {
            id = item.id;
          }
          return this.$http.post("/api/user/material/addMaterialCategory", {
            materialType: this.idsDict[uiType],
            materialId: id,
            categoryId: this.cateOptions[this.selectedCateIndex].id || 0,
            ourself: 1
          });
        });
        Promise.all(tasks).then(() => {
          this.getUserData(uiType);
        });
      }
    );
  },
  mounted () {
    this.$bus.on("manageMaterial_vue", data => {
      // 取消批量管理
      switch (data.step) {
        case 0: // 取消批量管理
          this.manageMaterialStepFS(2);
          break;
      }
    });

    this.$bus.on("modifyUserItem_del_vue", data => {
      // 取消收藏
      if (data.type && data.boxName == this.boxName) {
        if (this.manageMaterial.step == 2) {
          let urlData = data.type;
          switch (data.type) {
            case "gif":
              urlData = "pic";
              break;
            case "musicType":
              urlData = "music";
              break;
          }
          this.$http
            .delete("/api/user/" + urlData + "/" + this.manageMaterial.dataID) // 收藏scenes
            .then(resScenes => {
              this.manageMaterialStepFS(2);

              this.dataArray[data.type].pIndex = 1;
              this.dataArray[data.type].data = [];
              this.loading = true;
              this.getUserData(data.type);

              this.$message({
                showClose: true,
                message: "已删除作品",
                type: "success"
              });
            })
            .catch(Serror => { });
          return;
        }
        this.dataArray[data.type].pIndex = 1;
        this.dataArray[data.type].data = [];
        this.loading = true;
        this.getUserData(data.type);

        this.$message({
          showClose: true,
          message: "已删除作品",
          type: "success"
        });
      } else if (!data.boxName) {
        this.dataArray[data.type].pIndex = 1;
        this.dataArray[data.type].data = [];
        this.loading = true;
        this.getUserData(data.type);
      }
    });

    this.$bus.on("collectPersonal_vue", data => {
      this.$bus.emit("materialPane_vue", { type: "personal" });

      // let timeoutid = setTimeout(() => {
      if (data.data == "scenesSetting") {
        this.$bus.emit("personal_tab_FS_vue", { type: "collectionCategory" });
      } else {
        this.$bus.emit("personal_tab_FS_vue", { type: "personalCategory" });
      }
      switch (data.data) {
        case "scenesSetting": // 收藏场景页
          this.collectScenes();
          //this.scrollTop(0);
          break;
        case "modifyUserItem":
          this.getUserData("scene");
          break;
        case "collectPic": // 上传图片
          this.scrollTop(1);
          this.dataArray.pic.pIndex = 1;
          this.dataArray.pic.data = [];
          this.loading = true;
          this.getUserData("pic");
          if (!this.dataArray.pic.judge) {
            this.dataBoxAction("pic");
          }
          break;
        case "collectGif":
          this.scrollTop(4);
          this.dataArray.gif.pIndex = 1;
          this.dataArray.gif.data = [];
          this.loading = true;
          this.getUserData("gif");
          if (!this.dataArray.gif.judge) {
            this.dataBoxAction("gif");
          }
          break;
        case "collectMusic": // 上传背景音乐
        case "collectMusicType":
          this.scrollTop(2);
          this.dataArray.music.pIndex = 1;
          this.dataArray.music.data = [];
          this.loading = true;
          this.getUserData("music");
          if (!this.dataArray.music.judge) {
            this.dataBoxAction("music");
          }
          break;
        //video;
        // case "collectMusicType": // 上传录音
        //   this.scrollTop(3);
        //   this.dataArray.musicType.pIndex = 1;
        //   this.dataArray.musicType.data = [];
        //   this.loading = true;
        //   this.soundData.sceneSoundData = true;
        //   this.getUserData("musicType");
        //   if (!this.dataArray.musicType.judge) {
        //     this.dataBoxAction("musicType");
        //   }
        //   break;
        case "collectVideo": // 上传视频
          this.scrollTop(5);
          this.dataArray.video.pIndex = 1;
          this.dataArray.video.data = [];
          this.loading = true;
          this.getUserData("video");
          if (!this.dataArray.video.judge) {
            this.dataBoxAction("video");
          }
          break;
      }
      // clearTimeout(timeoutid);
      // }, 200);
    });

    this.$bus.on("rightSlideBoxAction_vue", data => {
      // 打开盒子
      if (data.type == this.boxName) {
        if (data.name == "musicType" && data.judge) {
          this.soundData.sceneSoundData = true;
        }
        if (!data.judge) {
          this.dataArray[data.name].pIndex = 1;
          this.dataArray[data.name].data = [];
        }
        if (!(this.dataArray[data.name] || {}).judge && data.judge) {
          this.dataBoxAction(data.name);
          this.personalGetData({ id: data.name });
          let scollId = 0;
          for (let i in this.personalCategory) {
            if (this.personalCategory[i].id == data.name) {
              break;
            }
            scollId++;
          }
          this.scrollTop(scollId);
        }
      }
    });

    this.$bus.on("upload_vue", data => {
      // 上传完成的发出事件
      if (
        data.type === "video" &&
        (data.name === "videoMe" || data.name === "videoAndImage")
      ) {
        this.$bus.emit("personal_tab_FS_vue", { type: "personalCategory" });
        this.materialPushAnalysis({ type: "videoUpload" });
        // 弹出气泡提示
        this.$bus.emit("showTips", {
          text: "在这里可以看到上传的背景视频。",
          position: {
            top: "250px",
            left: `${this.MaterialPane_Size.width + 15}px`
          }
        });
        let scenesData = {};

        scenesData.url = data.data.filename;
        scenesData.thumbnailUrl = data.fileName;
        scenesData.times = data.duration;
        scenesData.fileType = 26;

        this.$http
          .post("/api/user/video/uploadVideo", scenesData) // 收藏scenes
          .then(res => {
            let video = res.data.data;
            let fixed = (video.size / 1024 / 1024).toFixed(4);
            sensors.track('materialUpload', {
              material_id: video.id,
              material_type: '视频',
              material_size: fixed,
            });
            this.$bus.emit("collectPersonal_vue", { data: "collectVideo" });
            // 上传完成自动添加到背景
            this.$http
              .get("/api/user/video?sOfPage=24&fPage=24&pIndex=1&fileType=26")
              .then(res => {
                data.name === "videoMe" &&
                  this.addVideoSprite(res.data.data[0], "sprite");
                data.name === "videoAndImage" &&
                  this.settingScenesBg(res.data.data[0]);
              });

            this.$bus.emit("relateMaterialDone", {
              materials: [].concat(video),
              materialTypeName: 'video',
              multi: false,
            });
          })
          .catch(Serror => { });
      }
    });

    this.$bus.on("personalDataPick_vue", data => {
      // 录音文件上传成功监听
      switch (data.name) {
        case "musicType":
          this.$bus.emit("personal_tab_FS_vue", { type: "personalCategory" });
          if (data.pIndex == 1) {
            for (let i = 0; i < 3; i++) {
              if (this.dataArray.musicType.data[i]) {
                this.recordUploadFS(this.dataArray.musicType.data[i], i);
              }
            }
          }
          break;
      }
    });

    this.$bus.on("record_upload_success", data => {
      // 录音文件上传成功监听
      this.recordUploadData.judge = false;
      this.$bus.emit("collectPersonal_vue", { data: "collectMusicType" });
    });

    this.$bus.on("personal_tab_FS_vue", data => {
      // 切换个人收藏的tab
      if (this.personalTab != data.type) {
        this.personalTabFS(data.type);
      }
      if(data && data.action) {
        if(this.dataArray[data.action] && !this.dataArray[data.action].judge) {
          this.switchDataBoxAction(data.action);
        }
        let index = 0;
        if(this[data.type]) {
          for(let i in this[data.type]) {
            if(i === data.action) break;
            index++;
          }
        }
        this.scrollTop(index)
        if(this.dataArray[data.action]) {
          this.dataArray[data.action].pIndex = 1;
          this.dataArray[data.action].data = [];
        }
        this.getUserData(data.action)
      }
    });
  },
  methods: {
    personalGetData (item) {
      // if (item.id === 'music' || item.id === 'sound') {
      //   let el = $(this.$el).find('.' + item.id + '-wrapper')[0];
      //   let h = el ? el.offsetHeight : 0;
      //   if (h == 140) {
      //     this.$bus.emit('showNewSoundMsg', true);
      //   }
      // }
      if (!this.dataArray[item.id].data) {
        this.dataArray[item.id].data = [];
      }

      if (!this.dataArray[item.id].data.length) {
        this.getUserData(item.id);
      }
    },
    collectScenes () {
      // 收藏场景
      if (this.SelectScenes_Msg.resourceId) {
        for (let j = 0; j < this.IsVipSprites.data.length; j++) {
          if (
            this.SelectScenes_Msg.resourceId ===
            this.IsVipSprites.data[j].resourceId &&
            this.UserEquity.exclusiveBtn
          ) {
            // this.$bus.emit("FeaturesPop_vue", {
            //   name: "vipEquity",
            //   msg: "该场景页为VIP素材，如需收藏，还请升级为会员。",
            //   btnMsg: "升级为企业会员",
            //   btnMsgLink: "/workplace/vip",
            //   type: 2
            // });
            this.$modal.show("vipDialog", {
              msg: '该场景页为VIP素材，如需收藏，还请升级为企业会员。',
              target: "vip",
              type: "vip",
            });
            return;
          }
        }
      }

      this.dataArray.scenes.pIndex = 1;
      this.dataArray.scenes.data = [];
      this.loading = true;

      let scenesDom = this.SelectScenes_Msg.element.content.get(0);
      domtoimage
        .toBlob(scenesDom, { bgcolor: "#ffffff" })
        .then(dataUrl => {
          let filData = new FormData();
          filData.append("imageName", dataUrl);

          this.$http({
            // 截图
            url: "/api/upload/file",
            method: "post",
            data: filData,
            dataType: "json",
            processData: false,
            contentType: false
          })
            .then(response => {
              let scenesData = {},
                dataItem = this.cardingJson(
                  this.SelectScenes_Msg.toJson(),
                  "save"
                ),
                imgUrl = response.data.data.thumbnailName;

              this.myScenesData.bg = response.data.data.filename; // 保存场景的截图，判断当前场景的截图是否存在，不存在则替换

              // 配音json乱入
              let ts = [0, 0];
              for(let i = 0; i < this.TOOL.sprites.length; i++) {
                if(this.TOOL.sprites[i].id === this.SelectScenes_Msg.id) {
                  ts[1] = ts[0] + this.TOOL.sprites[i].duration / 1000;
                  break;
                }
                ts[0] += this.TOOL.sprites[i].duration / 1000;
              }
              dataItem.dubbing = this.soundHandle.getDubbingTS(ts);

              scenesData.data = JSON.stringify(dataItem);
              scenesData.title = "我的场景页~";
              scenesData.thumbnailUrl = imgUrl;
              this.$http
                .post("/api/user/scene", scenesData) // 收藏scenes
                .then(resScenes => {
                  this.dataArray.scenes.pIndex = 1;
                  if (!this.dataArray.scenes.judge) {
                    this.dataBoxAction("scenes");
                  }
                  this.getUserData("scenes");

                  this.$message({
                    message: "收藏场景成功",
                    type: "success"
                  });

                  // 弹出气泡提示
                  this.$bus.emit("showTips", {
                    text: '收藏的场景页都可以在"我的"找到。',
                    position: {
                      top: "186px",
                      left: this.MaterialPane_Size.width + "px"
                    }
                  });
                })
                .catch(Serror => { });
            })
            .catch(function (error) { });
        })
        .catch(function (error) {
          console.error("oops, something went wrong!", error);
        });
    },
    cardingJson (json, type) {
      // 梳理json存*添/
      json.resolution = {
        height: 1080,
        width: 1920
      };
      let scale = 1920 / this.TOOL.clientWidth;

      for (let j = 0, len = json.sprites.length; j < len; j++) {
        let item = json.sprites[j].outward;
        item.height = item.height * scale;
        item.width = item.width * scale;
        item.x = item.x * scale;
        item.y = item.y * scale;
        json.sprites[j].outward = item;

        let animation = json.sprites[j].stayEffect.animationGraphs;
        if (animation) {
          if ("toBounds" in animation[0]) {
            animation[0].toBounds.height = animation[0].toBounds.height * scale;
            animation[0].toBounds.width = animation[0].toBounds.width * scale;
            animation[0].toBounds.x = animation[0].toBounds.x * scale;
            animation[0].toBounds.y = animation[0].toBounds.y * scale;
          }
          if ("info" in animation[0]) {
            animation[0].info.height = animation[0].info.height *= scale;
            animation[0].info.width = animation[0].info.width *= scale;
            animation[0].info.points &&
              animation[0].info.points.forEach(function (point, i, arr) {
                for (var j = 0; j < point.length; j++) {
                  arr[i][j] = point[j] *= scale;
                }
              });
          }
          animation[0].path &&
            animation[0].path.forEach(function (val, i, arr) {
              arr[i] = val * scale;
            });
        }
      }
      // 镜头缩放
      json.cameras.forEach(function (camera, i, arr) {
        var m = camera.matrix;
        arr[i].matrix.w *= scale;
        arr[i].matrix.h *= scale;
        arr[i].matrix.x *= scale;
        arr[i].matrix.y *= scale;
      });
      return json;
    },
    modifyPopups (data, boxName, el) {
      // 修改title，tag
      if (this.manageMaterial.step == 1 && boxName === "musicType") {
        data.musicType = 1;
      }
      this.$bus.emit("FeaturesPop_vue", {
        name: "modifyUserItem",
        typeName: "bg",
        posx: this.TopNav_Size.width - 445,
        posy:
          el.clientY > this.Window_Size.height - 220
            ? this.Window_Size.height - 220
            : el.clientY,
        data: data,
        type: 2,
        boxName: boxName,
        typeName: this.boxName
      });
      this.$bus.emit("modifyUserItem_vue", {
        posx: this.TopNav_Size.width - 445,
        posy: el.clientY,
        data: data,
        boxName: boxName,
        typeName: this.boxName
      });
    },
    setToolSound (music) {
      // 设置全局音乐
      // 防止重复设置
      if (this.TOOL.sound && this.TOOL.sound.resourceId === music.id) return;

      // 添加背景音乐
      this.TOOL.setSound(
        {
          // 添加全局bgm
          resourceId: music.id, // 资源id 用于查询资源的信息，下同
          title: music.title,
          fileType: music.fileType,
          url: this.$handleAssetsUrl(music.url), // 资源路径
          isLoop: true, // 是否循环
          volume: 50, // 音量0-100
          subtitle: null, // 字幕（预留字段）
          endTime: 0,
          startTime: 0,
          trackingType: '1100'
        },
        true
      );
      this.showVolume();
    },
    setSceneSound (music) {
      // 设置当前场景音乐
      // 防止重复设置
      // this.$modal.show("modalRecordAddTo", {
      //   resourceId: music.id,
      //   id: music.id,
      //   url: this.$handleAssetsUrl(music.url),
      //   startTime: 0,
      //   fileType: music.fileType,
      //   title: music.title
      // });

      // this.TOOL.selectedScenes.setSound({
      //   resourceId :  music.id,
      //   id         :  music.id,
      //   url        :  this.$handleAssetsUrl(music.url),
      //   startTime  :  0,
      //   fileType   :  music.fileType,
      //   title      :  music.title,
      // }, true)
    },
    setSceneSound_ (music) {
      // 设置当前场景音乐
      this.SelectScenes_Msg.setSound(
        {
          trackingType: '1100',
          resourceId: music.id,
          id: music.id,
          url: this.$handleAssetsUrl(music.url),
          startTime: 0,
          fileType: music.fileType,
          title: music.title
        },
        true
      );

      // this.TOOL.soundRecordBackup[this.TOOL.selectedScenes.index] = this.TOOL.selectedScenes.getSound();
      let arr = this.TOOL.sprites.map(s => s.getSound());
      this.TOOL.setSoundRecord(arr, "scene", true);
      this.showVolume();
    },
    setSoundRecord (music) {
      // 设置全局录音
      this.TOOL.setSoundRecord(
        {
          resourceId: music.id,
          id: music.id,
          url: this.$handleAssetsUrl(music.url),
          startTime: 0,
          fileType: music.fileType,
          title: music.title,
          trackingType: '1100'
        },
        "global",
        true
      );
      this.showVolume();
    },
    testListenSound (data, load) {
      // 音乐播放控制
      if (load) {
        return;
      }
      let caseType = 0;
      if (this.soundData.testSound && this.soundData.testSound.id === data.id) {
        caseType = 1;
      }
      if (!data) {
        caseType = 2;
      }
      switch (caseType) {
        case 0:
          this.soundData.testSound = "";
          this.soundData.testSound = {
            url: data.url,
            id: data.id
          };
          let timeoutid = setTimeout(() => {
            this.soundData.testSound.dom = this.$refs.personalTestSound;
            this.soundData.testSound.dom.play();
            this.soundData.testSound.dom.addEventListener("timeupdate", () => {
              if (
                this.soundData.testSound.dom.currentTime + 0.05 >=
                this.soundData.testSound.dom.duration
              ) {
                this.soundData.playType = false;
              }
            });
            this.soundData.playType = true;
          }, 200);
          break;
        case 1:
          if (this.soundData.testSound.dom.paused) {
            this.soundData.testSound.dom.play();
            this.soundData.playType = true;
          } else {
            this.soundData.testSound.dom.pause();
            this.soundData.playType = false;
          }
          break;
        case 2:
          if (this.soundData.testSound) {
            this.soundData.testSound.dom.pause();
            this.soundData.playType = false;
          }
          break;
      }
    },
    imgErroeFs (e, data) {
      if (data.url) {
        let frequency = e.target.getAttribute("load-frequency");
        if (!frequency) {
          e.target.setAttribute("load-frequency", "0");
          frequency = 0;
        }
        if (frequency == 0) {
          if (e && e.target) {
            e.srcElement.src = e.srcElement.src.replace("nail", "");
          }
        }
        e.target.setAttribute("load-frequency", frequency - 0 + 1);
      }
    },
    sceneErroeFs (e) {
      if (this.myScenesData.bg && e && e.srcElement && e.srcElement.src) {
        let frequency = e.target.getAttribute("load-frequency");
        if (!frequency) {
          e.target.setAttribute("load-frequency", "0");
          frequency = 0;
        }
        if (frequency == 0) {
          e.srcElement.src = e.srcElement.src.replace("nail", "");
        }
        e.target.setAttribute("load-frequency", frequency - 0 + 1);
      }
    },
    resultFormat (duration) {
      if (duration <= 0) return "00:00";
      if (!duration) return "--:--";
      var min = ~~(duration / 60);
      min = (min + "").length === 1 ? "0" + min : min;
      var sec = Math.round(duration % 60);
      sec = (sec + "").length === 1 ? "0" + sec : sec;
      min = min || "00";
      sec = sec || "00";
      return min + ":" + sec;
    },
    showVolume () {
      this.$bus.emit("FeaturesPop_vue", {
        name: "volume_adjust",
        posx: 0,
        posy: 0,
        type: 1
      });
    },
    getPics (list = []) {
      //
      return list.filter(item => !/^(32|33|34)$/i.test(item.fileType));
    },
    getGifs (list = []) {
      return list.filter(item => /^(32|33|34)$/i.test(item.fileType));
    },
    switchBgSpritesFS (data) {
      let msgData = "";

      if (!this.dataArray.pic.data.length) {
        this.getUserData("pic");
      }
      if (
        (this.SelectSprites_Msg.length &&
          this.SelectSprites_Msg[0].type !== "Video") ||
        !this.SelectSprites_Msg.length
      ) {
        this.dataBoxAction("pic");
      }
      switch (data) {
        case 0:
          this.switchDataType = 0;
          this.personalCategory.pic.switchJudge.judge = true;
          if (this.personalCategory.gif) {
            this.personalCategory.gif.switchJudge.judge = true;
          }
          // this.personalCategory.scene.switchJudge.judge = true; // 个人场景与素材场景合并
          this.personalCategory.video.switchJudge.judge = true;
          this.personalCategory.music.switchJudge.judge = true;
          //this.personalCategory.musicType.switchJudge.judge = true;
          break;
        case 1: // 元素切换
          this.switchDataType = 1;
          msgData = "请选择图片、GIF或视频以替换素材";
          this.personalCategory.pic.switchJudge.judge = true;
          if (this.personalCategory.gif) {
            this.personalCategory.gif.switchJudge.judge = true;
          }
          // this.personalCategory.scene.switchJudge.judge = false;// 个人场景与素材场景合并
          this.personalCategory.video.switchJudge.judge = true;
          this.personalCategory.music.switchJudge.judge = false;
          //this.personalCategory.musicType.switchJudge.judge = false;
          break;
        case 2: // 背景切换
          this.switchDataType = 2;
          msgData = "请选择图片或视频以替换背景";
          this.personalCategory.pic.switchJudge.judge = true;
          if (this.personalCategory.gif) {
            this.personalCategory.gif.switchJudge.judge = false;
          }
          // this.personalCategory.scene.switchJudge.judge = false;// 个人场景与素材场景合并
          this.personalCategory.video.switchJudge.judge = true;
          this.personalCategory.music.switchJudge.judge = false;
          //this.personalCategory.musicType.switchJudge.judge = false;
          break;
      }
      if (this.personalCategory.gif) {
        this.personalCategory.gif.switchJudge.msg = msgData;
      }
      // this.personalCategory.scene.switchJudge.msg   = msgData;// 个人场景与素材场景合并
      this.personalCategory.video.switchJudge.msg = msgData;
      this.personalCategory.pic.switchJudge.msg = msgData;
      this.personalCategory.music.switchJudge.msg = msgData;
      //this.personalCategory.musicType.switchJudge.msg = msgData;
    },
    switchDataBoxAction (data) {
      let judgeBox =
        this.personalTab == "collectionCategory"
          ? true
          : this.personalCategory[data].switchJudge.judge;
      judgeBox && this.dataBoxAction(data);
    },
    picItemClickFS (data, type) {
      if (this.personalTab == "collectionCategory") {
        // 个人素材为收藏时
        this.settingScenesBg(data);
        this.materialPushAnalysis({ type: "imgSettingBg" });
      } else {
        let itemType = type || "pic";
        switch (this.switchDataType) {
          case 0:
          case 1:
            switch (itemType) {
              case "video":
                this.addVideoSprite(data, "sprite");
                this.$analysis(
                  "my_resource,click_video,我的资源_视频_点击视频"
                );
                break;
              case "pic":
                this.slidAddSprites(data);
                break;
            }
            break;
          case 2:
            switch (itemType) {
              case "video":
                this.addVideoSprite(data, "bg");
                this.materialPushAnalysis({ type: "imgSettingBg" });
                break;
              case "pic":
                this.settingScenesBg(data);
                this.materialPushAnalysis({ type: "imgSettingBg" });
                break;
            }
            break;
        }
      }
    },
    manageMaterialStepFS (data, dataMSG, e, category) {
      switch (data) {
        case 1: // 开始删除操作
          this.manageMaterial.step = 2;
          break;
        case 2: // 取消删除
          this.$bus.emit("FeaturesPop_close_vue", {
            name: "modifyUserItem",
            type: 2
          });
          this.manageMaterial.step = 1;
          this.manageMaterial.allIn = false;
          this.manageMaterial.dataArray = {};
          this.manageMaterial.dataID = "";
          break;
        case 3: // 删除
          if (this.manageMaterial.dataID) {
            this.modifyPopups(data, dataMSG, e);
          }
          break;
        case 4: // 添加id入栈
          if (this.manageMaterial.dataArray[dataMSG.id]) {
            delete this.manageMaterial.dataArray[dataMSG.id];
          } else {
            this.manageMaterial.dataArray[dataMSG.id] = dataMSG;
          }

          let description = 0;
          this.manageMaterial.dataID = "";
          for (let i in this.manageMaterial.dataArray) {
            if (this.manageMaterial.dataArray[i]) {
              this.manageMaterial.dataID += (description > 0 ? "," : "") + i;
              description++;
            }
          }

          this.manageMaterial.dataArray = { ...this.manageMaterial.dataArray };
          break;
        case "allIn":
          this.manageMaterial.dataArray = {};
          this.manageMaterial.dataID = "";
          if (!this.manageMaterial.allIn) {
            for (let i = 0; i < this.dataArray[dataMSG].data.length; i++) {
              let idata = this.dataArray[dataMSG].data[i];
              this.manageMaterialStepFS(4, idata);
            }
            this.materialPushAnalysis({ type: "personalAllIn" });
          } else {
            this.materialPushAnalysis({ type: "personalAllOut" });
          }
          this.manageMaterial.allIn = !this.manageMaterial.allIn;
          break;
      }
    },
    uploadFs (data, el) {
      switch (data) {
        case "audio":
          this.$bus.emit("FeaturesPop_vue", {
            type: 1,
            name: "textToVoice",
            initialX: this.MaterialPane_Size.width,
            initialY: el.clientY,
            posx: this.MaterialPane_Size.width,
            posy: el.clientY
          });
          break;
      }
    },
    recordUploadFS (data, index) {
      let resourcesDom = "audio";

      let domData = document.createElement(resourcesDom);
      domData.addEventListener("loadedmetadata", e => {
        this.recordUploadData["RU_" + index] = true;
        this.recordUploadData.delData; // 更新数据
        delete this.recordUploadData.delData; // 更新数据

        if (
          this.recordUploadData.RU_0 &&
          this.recordUploadData.RU_1 &&
          this.recordUploadData.RU_2
        ) {
          if (!this.recordUploadData.judge) {
            this.recordUploadData.judge = true;
            this.$message({
              message:
                "录音已准备好。您可打开右侧 “我的-录音” 模块来添加录音。",
              type: "success"
            });
          }
        }
      });
      domData.onerror = e => {
        this.recordUploadData["RU_" + index] = false;
        let timeoutid = setTimeout(() => {
          this.recordUploadFS(data, index);
          clearTimeout(timeoutid);
        }, 2000);
      };
      domData.src = this.$handleAssetsUrl(data.url);
    },
    addVideoSprite (data, type) {
      if (
        this.SpriteOperation === "swap" &&
        this.SpriteBeforeSwap.type === "Video"
      ) {
        this.slidAddSprites(data);
        return;
      }
      // if (this.BgOperation === 'swap') {
      //   this.settingScenesBg(data);
      //   return;
      // }

      // 关闭替换素材遮罩
      // this.$store.commit('save_BgOperation', 'add');

      this.$bus.emit("confirmAddVideo", {
        type: type, // 'bg' 'sprite'
        data: data
      });
    },
    personalTabFS (data) {
      this.personalTab = data;
      this.styleApiGetFs(data);
      this.$bus.emit("personal_tab_FS_new_vue", {
        type: this.personalTab
      });
    },

    setUserCategories () {
      // let cateName = $(this.$el).find('.data-body.operation').eq(0).data('cateName');
      let uiType = this.getUIType();
      this.$modal.show("setUserCategories", {
        requestingId: this.idsDict[uiType],
        list: this.cateOptions
      });
    },

    moveToCategory () {
      let uiType = this.getUIType();
      this.$modal.show("moveToCategory", {
        requestingId: this.idsDict[uiType],
        list: this.cateOptions,
        materialId: this.manageMaterial.dataID
      });
    },
    onAllSelectedChange (...args) {
      this.manageMaterialStepFS("allIn", this.getUIType());
    },
    isGifOrLottie (url) {
      return /\.gif$/.test(url) || /\.json$/.test(url);
    },
    getItemCategoryLabe (url) {
      if (/\.gif$/.test(url)) {
        return "GIF";
      }
      if (/\.png$/.test(url)) {
        return "PNG";
      }
      if (/\.jpeg$/.test(url)) {
        return "JPEG";
      }
      if (/\.jpg$/.test(url)) {
        return "JPG";
      }
      if (/\.json$/.test(url)) {
        return "Lottie";
      }
      if (/\.svg$/.test(url)) {
        return "SVG";
      }
    },
    isShowFolder (personalTab, itemName) {
      if (personalTab === "personalCategory") {
        if (this.BgOperation !== "swap") {
          return true;
        } else if (itemName === "pic" || itemName === "video") {
          return true;
        }
      } else {
        if (
          this.BgOperation !== "swap" ||
          (this.BgOperation === "swap" && itemName === "bg")
        ) {
          return true;
        }
      }
    }
  },
  components: {
    Search,
    DropDownMenu,
    NewSoundFeature
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.personal {
  width: 270px;
  min-height: 200px;
  border-radius: 8px;
  position: relative;
  padding-top: 50px;

  .personal_tab {
    width: 270px;
    height: 38px;
    background: #f0f0f8;
    display: flex;
    left: 0;
    transition: all 0.3s;
    z-index: 100;

    > div {
      width: 50%;
      height: 100%;
      line-height: 35px;
      cursor: pointer;
      background: #f0f0f8;
    }
    .active {
      background: #5778fb;
      color: #fff;
    }
  }

  .messageBar {
    top: 0px;
    left: 0px;
    z-index: 12;
    height: 35px;
    width: 270px;
    border-radius: 3px;
    text-indent: 0px;
    background-color: rgba(87, 120, 251, 0.65);
    text-align: left;
    line-height: 35px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: rgba(87, 120, 251, 0.8);
    }
  }

  .add-bg {
    width: 100%;
    height: auto;
    position: relative;
    cursor: pointer;

    div {
      height: 35px;
      width: 120px;
      margin-top: 20px;
      background-color: #ededf6;
      border-radius: 3px;
      text-indent: 25px;
      text-align: left;
      line-height: 35px;
      color: #474261;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #d9ddea;
      }
    }
    .audioScenesMsg {
      height: 35px;
      width: 275px;
      margin: 0 auto;
      margin-top: 10px;
      border-radius: 3px;
      text-indent: 0px;
      position: relative;

      &:hover {
        background-color: #a3a6cd;
      }
    }
  }
  section {
    width: 270px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #474261;
    right: 0;
    margin-bottom: 5px;
    background: #fff;
    img {
      width: 270px;
      height: 90px;
      background-color: #87307e;
      border-radius: 8px;
      margin-bottom: 9px;
      cursor: pointer;
    }
    .expand-line {
      width: 270px;
      height: 16px;
      background-color: #ccc;
    }
  }
  .switchData {
    width: 270px;
    height: 90px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #fff;
    right: 0;
    margin-bottom: 5px;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 8px;
  }
  .fix-switchData {
    position: absolute;
    top: 0 !important;
    left: 0 !important;
    cursor: not-allowed;
  }

  .data-body {
    // padding: 0 0 44px 0;
    padding: 0 0 77px 0;
    height: 140px;
    overflow: hidden;
    position: relative;

    .body-list {
      border-top: 2px solid #d6d3d3;
      position: relative;
      min-height: 88px;
      display: flex;
      flex-wrap: wrap;
      & > div:nth-child(1) {
        padding-top: 10px;
      }
      &:before {
        content: '';
        position: absolute;
        top: -6px;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 10px;
        height: 10px;
        background: #fff;
        transform: rotate(135deg);
        border-top: 2px solid #d6d3d3;
        border-right: 2px solid #d6d3d3;
      }
      .manageMaterial {
        width: 100%;
        // height: 70px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // padding-top: 10px;
        padding-bottom: 10px;

        .closeDel {
          color: #909399;
          background: #f4f4f5;
          border-color: #d3d4d6;

          &:hover {
            color: #fff;
            background-color: #909399;
            border-color: #909399;
          }
        }

        .personalSetting {
          position: relative;
          &:before {
            content: '';
            position: absolute;
            top: 9px;
            left: 10px;
            width: 10px;
            height: 10px;
            background: url('../../../../static/svg/personalSetting.svg')
              no-repeat center;
          }
        }
        .checkboxBtn {
          cursor: pointer;
          span {
            display: inline-block;
            width: 13px;
            height: 13px;
            border: 1px solid #666;
            vertical-align: middle;
            margin-right: 10px;
            border-radius: 3px;
            text-indent: -1px;
            font-size: 13px;
          }

          &:hover {
            color: #5778fb;
            span {
              border: 1px solid #5778fb;
            }
          }
        }
        .checkboxBtnActive {
          color: #5778fb;
          span {
            background: #5778fb;
            color: #fff;
            border: 1px solid #5778fb;
          }
        }
      }

      .item {
        width: 130px;
        height: 75px;
        margin-bottom: 15px;
        margin-right: 10px;
        border-radius: 3px;
        background: #fff;
        position: relative;
        border: 2px solid #eaeaf5;
        overflow: hidden;
        cursor: pointer;

        &:hover {
          border-color: #5778fb;
        }

        > img {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 0;
          margin: auto;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
        .manageMaterialMask {
          position: absolute;
          bottom: -4%;
          left: -4%;
          width: 108%;
          height: 108%;
          z-index: 5;
          color: #fff;
          font-size: 14px;
          text-align: left;
          .manageMaterialMaskIcon {
            font-weight: bold;
            position: absolute;
            top: 3px;
            left: 5px;
            cursor: pointer;
          }
          &:before {
            content: '';
            position: absolute;
            top: -5px;
            left: -20px;
            width: 0;
            height: 0;
            border-width: 0 25px 25px;
            border-style: solid;
            border-color: transparent transparent #d6d3d3;
            transform: rotate(-45deg);
            -ms-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -webkit-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            cursor: pointer;
          }
        }
        .manageMaterialMask:hover {
          &:before {
            border-color: transparent transparent #5175ff;
          }
        }
        .manageMaterialMaskAction {
          &:before {
            border-color: transparent transparent #5175ff !important;
          }
        }
        .maskItem {
          position: absolute;
          bottom: 0px;
          left: 0px;
          width: 100%;
          height: 100%;
          z-index: 0;
          .videoMsg {
            width: 100%;
            height: 100%;
            opacity: 0;
            background: #fff;
            color: #fff;
            transition: all 0.3s;
            padding-top: 18px;

            &:hover {
              background: rgba(0, 0, 0, 0.4);
              opacity: 1;
            }
          }
          &.disabled {
            background-color: rgba(#000, 0.7);
            cursor: not-allowed;
          }
        }

        .itemCategoryLabe {
          position: absolute;
          right: 0;
          height: 14px;
          border-radius: 7px;
          background-color: #4e4a68;
          color: #fefefe;
          font-size: 10px;
          padding: 0px 6px;

          > span {
            line-height: 14px;
            text-align: center;
          }
        }

        .modify,
        .label {
          position: absolute;
          bottom: 0px;
          left: 0px;
          z-index: 10;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
        }
        .modify {
          width: 50px;
          height: 50px;
          opacity: 0;
          z-index: 8;
          cursor: pointer;
          transition: all 0.3s;
        }
        .modifyScene {
          background: url('../../../../static/svg/closecollection.svg')
            no-repeat center;
          background-color: rgba(0, 0, 0, 0.6);
          background-size: 25px auto;
          &:hover {
            background: url('../../../../static/svg/closecollection.svg')
              no-repeat center;
            background-color: rgba(0, 0, 0, 0.8);
            background-size: 25px auto;
          }
        }
        .modifyBg {
          background: url('../../../../static/svg/settingbackground.svg')
            no-repeat center;
          background-color: rgba(0, 0, 0, 0.6);
          background-size: 20px auto;
          &:hover {
            background: url('../../../../static/svg/settingbackground.svg')
              no-repeat center;
            background-color: rgba(0, 0, 0, 0.8);
            background-size: 20px auto;
          }
        }
        .modifyImg {
          background-image: url('../../../../static/svg/edit-display-white.svg');
          background-size: 20px 18px;
          background-repeat: no-repeat;
          background-position: center;
        }
        &:hover {
          .modify {
            opacity: 1;
          }
        }
      }
      .persona_flex_margin_right.odd-index {
        margin-right: 0;
      }
      .collection_flex_margin_right.odd-index {
        margin-right: 0;
      }
      .manageMaterialItemAction {
        border-color: #5175ff;
      }

      .label {
        position: absolute;
        bottom: 5px;
        right: 5px;
        width: 30px;
        height: 18px;
        background: #d83d60;
        color: #fff;
        border-radius: 5px;
        line-height: 18px;
        text-indent: 0px;
        text-align: center;
      }
      .label {
        bottom: 4px;
        right: 50px;
      }
      .itemAudio:nth-child(1) {
        margin-top: 5px;
      }
      .loadingOut {
        background: #e7e7fb;
        .loadingOutMsg {
          font-family: MicrosoftYaHei;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #5778fb;
        }
      }
      .itemProps,
      .itemText {
        width: 80px;
        height: 80px;
        margin-right: 15px;
      }
      .itemShapes {
        &:hover {
          border-color: #5778fb;
          .Clottie {
            opacity: 1;
            z-index: 5;
          }
          > .Imglottie {
            opacity: 0;
            z-index: 0;
          }
        }

        .mask,
        .Clottie {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          opacity: 0;
          z-index: 0;
          transition: all 0.3s;
          height: 100%;
        }
      }
      .itemProps {
        &:hover {
          border-color: #5778fb;
          .Clottie {
            opacity: 1;
            z-index: 5;
          }
          > .Imglottie {
            opacity: 0;
            z-index: 0;
          }
        }
        .mask,
        .Clottie {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          opacity: 0;
          z-index: 0;
          transition: all 0.3s;
          height: 100%;
        }
        > video,
        > img {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          z-index: 5;
          margin: auto;
          width: auto;
          height: auto;
          max-width: 100%;
          max-height: 100%;
        }
      }

      .itemProps:nth-child(3n + 0) {
        margin-right: 0px;
      }
      .itemText:nth-child(3n + 0) {
        margin-right: 0px;
      }
    }
    .fix-section-top {
      // position: fixed;
      top: 130px;
      right: 82px;
      z-index: 10;
      transition: all 0.3s;
    }
  }
}

.manage-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #474261;
  cursor: pointer;
  &.disabled {
    color: #aca8c4;
    cursor: not-allowed;

    &.move > i {
      background-image: url(../../../../static/svg/user-categories/move-gray.svg);
      background-repeat: no-repeat;
    }
    &.remove > i {
      background-image: url(../../../../static/svg/user-categories/remove-gray.svg);
      background-repeat: no-repeat;
    }
  }
  & > i {
    width: 16px;
    height: 16px;
    margin-right: 6px;
  }
  &.manage > i {
    background-image: url(../../../../static/svg/user-categories/manage.svg);
    background-repeat: no-repeat;
  }
  &.cate > i {
    background-image: url(../../../../static/svg/user-categories/cate.svg);
    background-repeat: no-repeat;
  }
  &.move > i {
    background-image: url(../../../../static/svg/user-categories/move.svg);
    background-repeat: no-repeat;
  }
  &.remove > i {
    background-image: url(../../../../static/svg/user-categories/remove.svg);
    background-repeat: no-repeat;
  }
  &.cancel > i {
    background-image: url(../../../../static/svg/user-categories/cancel.svg);
    background-repeat: no-repeat;
  }
}

.itemAudio {
  display: flex;
  flex-direction: row;
  width: 270px;
  height: 60px;
  margin-top: 3px;
  border-radius: 3px;
  background-color: #fafafd;
  border-radius: 4px;
  border: solid 1px #dbdff0;
  position: relative;
  align-items: center;
  overflow: hidden;

  .manageMaterialMaskAudio {
    width: 25px;
    height: 25px;
    border: 1px solid #d8ddea;
    border-radius: 10%;
    cursor: pointer;
    font-size: 18px;
    font-weight: 900;
    text-align: center;
    line-height: 23px;
    text-indent: 0px;
    color: #5175ff;
    background: #fff;
    &:hover {
      border-color: #5175ff !important;
    }
  }

  .select,
  .select-active,
  .delAudio {
    display: inline-flex;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    cursor: pointer;
  }

  .delAudio {
    opacity: 0;
    margin-right: 10px;
  }

  .select {
    margin: 0px;
    background: url('../../../../static/svg/select.svg') no-repeat center;
    &:hover {
      background: url('../../../../static/svg/select-active.svg') no-repeat
        center;
    }
  }
  .select-active {
    background: url('../../../../static/svg/select-active.svg') no-repeat center;
  }
  .delAudio {
    background: url('../../../../static/svg/del.svg') no-repeat center;
    &:hover {
      background: url('../../../../static/svg/delaction.svg') no-repeat center;
    }
  }

  &:hover {
    background-color: #dbdff0;

    .delAudio {
      opacity: 1;
    }
    .selectedGrid {
      display: flex;
    }
    .staticGrid {
      display: none;
    }
  }
  .play,
  .stop {
    display: block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
  }
  .play {
    background: url('../../../../static/svg/materialPane/music/play.svg')
      no-repeat center;
  }
  .stop {
    background: url('../../../../static/svg/materialPane/music/pause.svg')
      no-repeat center;
  }
  div.detail {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    p.name {
      display: block;
      color: #474261;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      max-width: 130px;
    }
    p.duration {
      position: absolute;
      top: 5px;
      right: 5px;
      color: #a5a7c6;
      text-align: left;
      font-size: 12px;
    }
  }

  .modify,
  .label {
    position: absolute;
    bottom: 5px;
    right: 5px;
    width: 30px;
    height: 18px;
    background: #d83d60;
    color: #fff;
    border-radius: 5px;
    line-height: 18px;
  }
  .label {
    bottom: 40px;
    right: 2px;
  }
  .modify {
    width: 35px;
    height: 35px;
    opacity: 0;
    cursor: pointer;
    transition: all 0.3s;
  }
  &:hover {
    .modify {
      opacity: 1;
    }
  }

  .playGrid {
    width: 52px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .detailGrid {
    position: relative;
    flex-grow: 1;
    //background-color: red;
    height: 100%;
    width: 137px;
    .name {
      position: absolute;
      display: block;
      color: #474261;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      max-width: 130px;
      top: 13px;
    }
    .duration {
      position: absolute;
      top: 35px;
      left: 0px;
      color: #a5a7c6;
      text-align: left;
      font-size: 12px;
    }
  }
  .infoGrid {
    position: relative;
    width: 81px;
    height: 100%;
    .staticGrid {
      position: absolute;
      right: 0;
      width: 63px;
      height: 100%;
      .logoGrid {
        position: absolute;
        top: 13px;
        right: 10px;
      }
      .payGrid {
        position: absolute;
        width: 100%;
        height: 18px;
        left: -10px;
        right: 0px;
        top: 38px;
      }
    }
    .selectedGrid {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      width: 100%;
      height: 100%;
    }
  }
}
.set-sound-content {
  width: 150px;
  margin-left: -13px;

  div {
    padding: 5px;
    text-align: center;
    cursor: pointer;

    &:last-child {
      margin-bottom: 0;
    }

    &:hover {
      background-color: #d9dde9;
    }
  }
}

.info-trigger {
  border: 2px #333 solid;
  border-radius: 50%;
  display: inline-block;
  color: #333;
  width: 20px;
  height: 20px;
  font-weight: bold;
  transform: scale(0.6) translatey(5px);
}
</style>



// WEBPACK FOOTER //
// src/components/rightnav/slide/personal.vue